import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * ENVIAR E-MAIL, SMS E WHATSAPP PARA ESTUDANTES / RESPONSÁVEIS — migração de
 * `MenuAcademico/EnviarEmailSMS.aspx`.
 *
 * O envio NÃO passa mais pela Kernel: sai pelo módulo de envio da própria API acadêmica, com a
 * configuração da ESCOLA (ou, na falta dela, a da REDE) cadastrada em Administração → Configuração
 * de envios. Permissão PRÓPRIA (300100799), vizinha da legada (300100700).
 */
export default [
  {
    description: 'Enviar E-mail, SMS e WhatsApp',
    path: '/academico/mensagens',
    name: 'enviar_mensagem_estudantes',
    component: () => import('@/views/academico/mensagens/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ENVIAREMAILPARAESTUDANTEPAISNOVO_MENU_300100799],
    },
    goesToMenu: true,
  },
];
